import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { AddtokeywordsComponent } from './addtokeywords.component';


const routes: Routes = [
    {
        path: 'addtokeywords',
        component: AddtokeywordsComponent,
        data: {
            permission: {
                only: ['role1', 'role2']
            }
        },
        canActivate: [AuthGuard, RoleGuard]
    }
];

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        AddtokeywordsComponent
    ],
    entryComponents: [],
    providers: [
        AuthGuard, RoleGuard
    ]
})
export class AddtokeywordsModule { }



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/addtokeywords/addtokeywords.module.ts